<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Forms &nbsp;
          <add-button link="/form-management/forms/create"></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Form Management</li>
          <li class="breadcrumb-item">Forms</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportforms.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="forms_excel"
                    :fields="excel_fields"
                    worksheet="Forms"
                    name="Form.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Form Type</th>
                    <th>Data Type</th>
                    <th>Category</th>
                    <th>Title</th>
                    <th>Code</th>
                    <th>Date</th>
                    <th>Edited By</th>
                    <th>Company</th>
                    <th>Remarks</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="forms.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr v-for="(form, at) in forms" :key="`form${at}`">
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ form.form_type }}</td>
                    <td>
                      {{ form.data_type }}
                    </td>
                    <td>
                      {{ form.category ? form.category.name : "" }}
                    </td>
                    <td>{{ form.title }}</td>
                    <td>{{ form.code }}</td>
                    <td>{{ form.date }}</td>
                    <td>{{ form.edited_by }}</td>
                    <td>{{ form.organization.name }}</td>
                    <td>{{ form.remarks }}</td>
                    <!-- <td>
                      <img
                        v-if="form.logo"
                        :src="`${mediaUrl + form.logo}`"
                        alt=""
                        srcset=""
                      />
                      <span v-else></span>
                    </td> -->
                    <td>
                      <div>
                        <router-link
                          :to="`/form-management/forms/${form.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(form.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "form",
  data() {
    return {
      forms: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      forms_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        "Form Type": "form_type",
        "Data Type": "data_type",
        Category: "category",
        Title: "title",
        Code: "code",
        Date: "date",
        "Edited By": "edited_by",
        Company: "organization",
        Remarks: "remarks",
      },
      Exportforms: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let forms = await axios.get(
        `/forms?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.forms = forms.data.data;
      this.count = forms.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let forms = await axios.get(`/forms?search=${this.searchData}`);
      this.forms = forms.data.data;
      this.count = forms.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Form Data";
      this.forms_excel = [];
      let Exportforms = [];
      Exportforms = await axios.get(`/forms`);
      this.Exportforms = Exportforms.data.data;
      let sr_no = 1;
      this.Exportforms.forEach((form) => {
        this.forms_excel.push({
          sr_no: sr_no,
          form_type: form.form_type ? form.form_type : "",
          data_type: form.data_type ? form.data_type : "",
          category: form.category ? form.category.name : "",
          title: form.title ? form.title : "",
          code: form.code ? form.code : "",
          date: form.date ? form.date : "",
          edited_by: form.edited_by ? form.edited_by : "",
          organization: form.organization.name ? form.organization.name : "",
          remarks: form.remarks ? form.remarks : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=forms`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
